import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-accent-900 border-t border-background-200/60 text-foreground-700">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10 max-w-screen mx-auto">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-3">
              <span className="w-8 h-8 rounded-md bg-primary-500 flex items-center justify-center">
                <i className="ri-film-line text-lg text-background-50"></i>
              </span>
              <span className="text-lg font-bold text-foreground-950">
                午夜<span className="text-primary-500">电影网</span>
              </span>
            </Link>
            <p className="text-sm leading-relaxed max-w-md text-foreground-700">
              午夜电影网致力于为广大电影爱好者提供丰富的高清电影资源与最新影视资讯。在这里，你可以按类型、年份、地区与评分自由筛选心仪的影片，也能第一时间了解行业动态与深度影评。
            </p>
            <p className="text-xs mt-4 text-foreground-600">
              本站所有影片信息、资讯内容均为演示数据，在线播放为前端演示，不含真实播放接口。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-3">
              <a href="#footer-nav">快速导航</a>
            </h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/movies" className="hover:text-primary-400 transition-colors">电影分类</Link></li>
              <li><Link to="/news" className="hover:text-primary-400 transition-colors">电影资讯</Link></li>
              <li><Link to="/specials" className="hover:text-primary-400 transition-colors">专题合集</Link></li>
              <li><Link to="/search" className="hover:text-primary-400 transition-colors">搜索影片</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-3">
              <a href="#footer-links">友情链接</a>
            </h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#footer-links" className="hover:text-primary-400 transition-colors">华语电影资料库</a></li>
              <li><a href="#footer-links" className="hover:text-primary-400 transition-colors">全球票房观察</a></li>
              <li><a href="#footer-links" className="hover:text-primary-400 transition-colors">独立影展资讯</a></li>
              <li><Link to="/about" className="hover:text-primary-400 transition-colors">关于我们</Link></li>
            </ul>
          </div>
        </div>

        <div className="max-w-screen mx-auto mt-10 pt-6 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">© 2026 午夜电影网 Midnight Movie. 保留所有权利。</p>
          <p className="text-xs text-foreground-600">本站为演示项目 · 内容仅供学习交流</p>
        </div>
      </div>
    </footer>
  );
}